'use strict';
import addProductToCart from './product/addToCart';
import ajax from '../ajax';
import page from '../page';
import productTile from '../product-tile';
import quickview from '../quickview';

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
	$('#compare-table').on('click', '.remove-link', function (e) {
			e.preventDefault();
			ajax.getJson({
				url: this.href,
				callback: function () {
					page.refresh();
				}
			});
		})
		.on('click', '.open-quick-view', function (e) {
			e.preventDefault();
			var url = $(this).closest('.product').find('.thumb-link').attr('href');
			quickview.show({
				url: url,
				source: 'quickview'
			});
		});

	$('#compare-category-list').on('change', function () {
		$(this).closest('form').submit();
	});
}

export default {
	init: function () {
		productTile.init();
		initializeEvents();
		addProductToCart();
	}
};